import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

import style from "./ErrorPage.module.css";

const ErrorPage: React.FC = () => {
  return (
    <div className={style.container}>
      <img
        src="https://s3-eu-west-1.amazonaws.com/shapr3d-assets/images/engine-model.png"
        alt="illustration"
        className={style.illustration}
      />
      <div className={style.message}>
        <div>Something went wrong. Please try again or follow </div>
        <NewZendeskTicketLink>
          <span className={style.link}>this link</span>
        </NewZendeskTicketLink>{" "}
        to submit a support ticket.
      </div>
    </div>
  );
};

export default ErrorPage;
